// Saisie de montants en dollars (« 1 200,00 », « 89.99 », « 150 $ ») ↔ cents.

export function parseAmountToCents(input: string): number | null {
  const cleaned = input.replace(/[\s$]/g, "");
  if (!cleaned) return 0;
  const normalized = cleaned.replace(",", ".");
  const n = Number(normalized);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

export function centsToInput(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return "";
  return (cents / 100).toFixed(2);
}
